import { DEFAULT_CONFIG } from "./data/default-config";
import { createInitialEntities } from "./data/default-setup";
import type { ParticipantId } from "./types/common";
import type {
  InitialEntitySeed,
  StoneFlickingCoreConfig,
} from "./types/game-config";
import type { Participant, StoneFlickingCoreState } from "./types/game-state";

export interface ParticipantConfig {
  readonly id: ParticipantId;
  readonly name: string;
}

export interface InitMatchOptions {
  readonly participantConfigs?: ReadonlyArray<ParticipantConfig>;
  readonly config?: StoneFlickingCoreConfig;
  readonly initialEntities?: ReadonlyArray<InitialEntitySeed>;
  readonly hostPlayerId?: string;
}

const DEFAULT_PARTICIPANT_CONFIGS: ReadonlyArray<ParticipantConfig> = [
  { id: "P1", name: "Participant 1" },
  { id: "P2", name: "Participant 2" },
];

export function initMatch(
  options: InitMatchOptions = {},
): StoneFlickingCoreState {
  const {
    participantConfigs = DEFAULT_PARTICIPANT_CONFIGS,
    config = DEFAULT_CONFIG,
    initialEntities,
  } = options;

  const participants: ReadonlyArray<Participant> = participantConfigs.map(
    (pc) => ({ id: pc.id, name: pc.name }),
  );

  const participantIds = participants.map((p) => p.id);

  return {
    phase: "INPUT_PHASE",
    round: 1,
    participants,
    eliminatedParticipants: [],
    pendingInputs: new Map(),
    submittedParticipants: [],
    entities: createInitialEntities(
      config.archetypes,
      participantIds,
      initialEntities,
    ),
    winner: null,
    outcomeReason: null,
    isDraw: false,
    lastRecording: null,
    hostPlayerId: options.hostPlayerId ?? participantIds[0] ?? "",
  };
}
